import { css } from "@emotion/react";

export const poweredBy = css`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const poweredByLogo = css`
  height: 14px;
  width: auto;
`;
